import "./App.css";
import { useTheme } from "./Context/ThemeContext";
import Layout from "./components/Layout/Layout";
import MobileNav from "./components/MobileNav/MobileNav";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Education from "./pages/Education/Education";
import Projects from "./pages/Projects/Projects";
import Tech from "./pages/Techstack/Tech";
import ScrollToTop from "react-scroll-to-top";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [theme] = useTheme();

  return (
    <>
      <div id={theme}>
        <ToastContainer />
        <MobileNav />
        <Layout />
        <div className="container ">
          <About />
          <Tech />
          <Education />
          <Projects />
          <Contact />
        </div>

        <div className="footer pb-3 ms-4">
          <h6 className="text-center bg-danger">
            💀Made for Shivam Mishra by ©Shivam Mishra <br />
          </h6>
        </div>
      </div>
      <div className="scroll">
        <ScrollToTop
          className="scrolltoTop"
          smooth
          color="aqua"
          style={{
            backgroundColor: "black",
            margin: "-2%",
            borderRadius: "50%",
          }}
        />
      </div>
    </>
  );
}

export default App;
